import React from 'react';
import PropTypes from 'prop-types';
import SkeletonText from '../Skeleton/SkeletonText';
import InterfaceStorage from '../Site/InterfaceStorage';

export default class BaseAbstract extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            value: null,
            hasValue: false,
        };
    }

    static get propTypes() {

        return {
            uid: PropTypes.string.isRequired,
            className: PropTypes.string,
            skeletonClassName: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
            skeletonProps: PropTypes.object,
            isHtml: PropTypes.bool,
            storage: PropTypes.oneOfType([PropTypes.oneOf(InterfaceStorage.getAll()), PropTypes.array]),
        };
    }

    setValue(value) {

        this.setState({ value, hasValue: true });
    }

    componentDidMount() {

        InterfaceStorage.registerComponent(this.props.uid, this.props.storage ?? 'memory', this);
    }

    render() {

        return this.state.hasValue
            ? this.renderValue()
            : this.renderSkeleton();
    }

    renderValue() {

        return this.props.isHtml
            ? <div className={ this.props.className } dangerouslySetInnerHTML={{ __html: this.state.value }} />
            : <div className={ this.props.className }>{ this.state.value }</div>;
    }

    renderSkeleton(props = {}) {

        const skeletonClassName = (this.props.skeletonClassName === true)
            ? this.props.className
            : this.props.skeletonClassName;

        return <SkeletonText
            className={ this.props.className }
            skeletonClassName={ skeletonClassName } { ...Object.assign(this.props.skeletonProps ?? {}, props) } />;
    }
    
}